export default "__VITE_ASSET__DBhTNuUI__"